export const NeoValue: React.FC<any> = ({data, cellValue}) => {
  return (
    <div className="flex flex-col">
      <p className="text-bold text-small capitalize">{cellValue}</p>
    </div>
  );
};
